import PageView from "./components/PageView";
import "./styles.css";

function App() {
  return <PageView />;
}

export default App;
